module.exports = __webpack_public_path__ + "static/media/features4.ab70a1de.jpg";